import { render, staticRenderFns } from "./work-packages.vue?vue&type=template&id=6560c7a7&scoped=true"
import script from "./work-packages.vue?vue&type=script&lang=js"
export * from "./work-packages.vue?vue&type=script&lang=js"
import style0 from "./work-packages.vue?vue&type=style&index=0&id=6560c7a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6560c7a7",
  null
  
)

export default component.exports